import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';

/**
 * Client for the G2 in-app review endpoints (#28067).
 * adminSvcUrl already ends in /api/, so routes omit the api/ prefix.
 * Auth (GratSync-Token / GratSync-Portal) is attached automatically by BaseClient.
 */
@Injectable({
  providedIn: 'root',
})
export class ReviewsClient extends BaseClient {
  constructor() {
    super();
  }

  // GET reviews/g2/link -> { Url } (mints a G2 embed URL for the current user).
  // Errors are handled by the caller (BE-8 envelope), so error notifications are suppressed.
  getG2Link(message?: string) {
    return this.get(
      SvcClients.AdminSvc,
      'reviews/g2link',
      message,
      undefined,
      true,
      null,
      true
    );
  }

  // POST reviews/g2/event -> funnel analytics. Fire-and-forget; suppress error notifications.
  postG2Event(eventType: string, metadata?: string, message?: string) {
    return this.post(
      SvcClients.AdminSvc,
      'reviews/g2event',
      { eventType: eventType, metadata: metadata },
      message,
      undefined,
      true,
      null,
      true
    );
  }
}
